import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import { InvoiceDigestStatus } from 'anchor-scout-common/types';
import { Divider, TableList, Typography } from 'seagull';
import { routes } from "../../../constants";
import { useLocaleKeys } from "../../../i18n";
import { invoiceStatusToColor } from "./InvoicesDigestWidget";
import styles from "./InvoicesDigestWidget.module.scss";
import { invoicePaymentStatusMap } from "./InvoicesDigestWIdget.utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const renderCell = _ref => {
  let {
    value,
    testId
  } = _ref;
  return {
    value: /*#__PURE__*/_jsx(Typography, {
      testId: testId,
      children: value
    })
  };
};
const renderDivider = () => /*#__PURE__*/_jsx(Divider, {
  margin: 0
});
const renderHeaderItem = value => ({
  value: /*#__PURE__*/_jsx(Typography, {
    weight: "normal",
    children: value
  })
});
const invoicesDigestTableTextsPath = 'pages.dashboard.invoicesDigestWidget';
const invoiceTypeToTypeCellText = (type, texts) => {
  switch (type) {
    case InvoiceDigestStatus.RequiresClientApproval:
      return texts.statusLabels.requiresClientApproval();
    case InvoiceDigestStatus.PaymentsVerificationRequired:
      return texts.statusLabels.paymentsVerificationRequired();
    case InvoiceDigestStatus.MissingPaymentMethod:
      return texts.statusLabels.missingPaymentMethod();
    case InvoiceDigestStatus.Failed:
      return texts.statusLabels.failed();
    case InvoiceDigestStatus.Disputed:
      return texts.statusLabels.disputed();
    case InvoiceDigestStatus.PaymentStopped:
      return texts.statusLabels.paymentStopped();
    case InvoiceDigestStatus.PaymentMethodUnverified:
      return texts.statusLabels.paymentMethodUnverified();
  }
};
function InvoiceInfoRow(_ref2) {
  let {
    invoiceStatusGroup,
    invoiceType,
    testId,
    className,
    isLast
  } = _ref2;
  const {
    t
  } = useLocaleKeys(invoicesDigestTableTextsPath);
  const paymentStatus = 'paymentStatus';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TableList.Row, {
      disableMarginBottom: true,
      highlightOnHover: true,
      as: NavLink,
      size: "fluid",
      className: className,
      to: "".concat(routes.invoicesDashboard, "?").concat(paymentStatus, "=").concat(invoicePaymentStatusMap[invoiceType]),
      testId: testId,
      items: [{
        value: /*#__PURE__*/_jsxs("div", {
          className: cn(styles.dotContainer),
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.dot,
            style: {
              background: invoiceStatusToColor[invoiceType]
            }
          }), /*#__PURE__*/_jsx(Typography, {
            children: invoiceTypeToTypeCellText(invoiceType, t)
          })]
        })
      }, renderCell({
        value: invoiceStatusGroup.count.toString()
      }), renderCell({
        value: invoiceStatusGroup.amount.display()
      })]
    }), !isLast && renderDivider()]
  });
}
function InvoicesInfoTable(_ref3) {
  let {
    invoiceDigestModel
  } = _ref3;
  const {
    t
  } = useLocaleKeys(invoicesDigestTableTextsPath);
  const invoicesInfoRowTestId = type => "invoices-digest-".concat(type, "-row");
  const rows = invoiceDigestModel.invoiceTypesToDisplay();
  const className = invoiceDigestModel.numInvoiceTypes() < 6 ? styles.lessThanSixItemsInvoiceInfoRow : styles.sixItemsInvoiceInfoRow;
  const {
    columnDefs,
    headerItems
  } = (() => {
    const config = [{
      columnDef: {
        width: 240
      },
      headerItem: renderHeaderItem(t.tableHeaders.type())
    }, {
      columnDef: {
        width: [60, 80],
        hAlign: 'end'
      },
      headerItem: renderHeaderItem(t.tableHeaders.invoices())
    }, {
      columnDef: {
        width: [100, 150],
        hAlign: 'end'
      },
      headerItem: renderHeaderItem(t.tableHeaders.amount())
    }];
    return {
      columnDefs: config.map(i => i.columnDef),
      headerItems: config.map(i => i.headerItem)
    };
  })();
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "invoice-digest-table",
    children: /*#__PURE__*/_jsxs(TableList.Provider, {
      variant: "minimal",
      columnDefs: columnDefs,
      hPadding: "xs",
      children: [/*#__PURE__*/_jsx(TableList.Header, {
        items: headerItems,
        bgColor: "transparent"
      }), renderDivider(), rows.map((invoiceType, idx) => {
        const invoiceStatusGroup = invoiceDigestModel.invoiceTypeToInvoicesGroup(invoiceType);
        return /*#__PURE__*/_jsx(InvoiceInfoRow, {
          testId: invoicesInfoRowTestId(invoiceType),
          invoiceType: invoiceType,
          invoiceStatusGroup: invoiceStatusGroup,
          className: className,
          isLast: idx === rows.length - 1
        }, invoiceType);
      })]
    })
  });
}
export default InvoicesInfoTable;